import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Card,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import Paypal from "../../components/PaypalPayment";
import {
    buyMomento,
    fetchMoreGallery,
    getAllMomentos,
} from "../../store/actions/FanActions";
import { checkBoughtMomentos } from "../../store/actions/MomentosActions";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const Gallery = () => {
    const dispatch = useDispatch();
    const { uid } = useSelector((state) => state.authUser);
    const {
        fanGallery,
        fanLoading,
        lastFanGalleryDocument,
        hasMoreFanGallery,
    } = useSelector((state) => state.fanReducer);
    const [loader, setLoader] = useState({
        data: false,
        loadMore: false,
        applyFilter: false,
        clearFilter: false,
    });
    const [momentosGallery, setMomentosGallery] = useState([]);
    const [loadMoreBtn, setLoadMoreBtn] = useState(false);
    const [allowDetailsIndex, setAllowDetailsIndex] = useState(-1);
    //  const [searchByName, setSearchByName] = useState("");
    const [searchByFirstName, setSearchByFirstName] = useState("");
    const [searchByLastName, setSearchByLastName] = useState("");

    const [searchByID, setSearchByID] = useState("");
    const [searchByMementoID, setSearchByMementoID] = useState("");
    const [buyMomentoIndex, setBuyMomentoIndex] = useState(-1);
    const [buyMomentoObj, setBuyMomentoObj] = useState("");
    const [buyerModal, setBuyerModal] = useState(false);
    const [acceptedRules, setAcceptedRules] = useState(false);
    let url = useParams();
    const urlParams = new URLSearchParams(window.location.search);
    const redirectPath = urlParams.get("momentoId");
    useEffect(() => {
        if (redirectPath) {
            setSearchByMementoID(redirectPath);
        }
        setLoader((prev) => ({
            ...prev,
            data: true,
        }));
        dispatch(
            getAllMomentos(
                {
                    athleteFirstName: "",
                    momentoID: "",
                    athleteID: "",
                },
                "",
                () => {
                    setLoader((prev) => ({
                        ...prev,
                        data: false,
                    }));
                }
            )
        );
    }, []);
    useEffect(() => {
        // if (fanGallery?.length > 0) {
        setMomentosGallery(fanGallery);
        // }
    }, [fanGallery]);

    // useEffect(() => {
    //     if (searchByFirstName) {
    //         const filteredMomentos = fanGallery.filter((momento) => {
    //             const firstName = momento.athleteName.split(" ");
    //             console.log("name", firstName);
    //             return firstName[0]
    //                 .toLowerCase()
    //                 .includes(searchByFirstName.toLowerCase());
    //         });
    //         setMomentosGallery(filteredMomentos);
    //     } else if (searchByLastName) {
    //         const filteredMomentos = fanGallery.filter((momento) => {
    //             const firstName = momento.athleteName.split(" ");
    //             console.log("name", firstName);
    //             return firstName[1]
    //                 .toLowerCase()
    //                 .includes(searchByLastName.toLowerCase());
    //         });
    //         setMomentosGallery(filteredMomentos);
    //     } else if (searchByID) {
    //         const filteredMomentos = fanGallery.filter((momento) => {
    //             return momento?.athleteID?.toString()?.includes(searchByID);
    //         });
    //         setMomentosGallery(filteredMomentos);
    //     } else if (searchByMementoID) {
    //         console.log(searchByMementoID);
    //         const filteredMomentos = fanGallery.filter((momento) => {
    //             return momento?.momentoID
    //                 ?.toString()
    //                 ?.includes(searchByMementoID);
    //             // .toLowerCase()
    //             // .includes(searchByMementoID.toLowerCase());
    //         });
    //         setMomentosGallery(filteredMomentos);
    //     } else {
    //         setMomentosGallery(fanGallery);
    //     }
    //     console.log("fan Gallery", fanGallery);
    // }, [
    //     searchByID,
    //     searchByFirstName,
    //     searchByLastName,
    //     searchByMementoID,
    //     fanGallery,
    // ]);

    const formatDate = (date) => {
        const unixTimestamp = date.seconds + date.nanoseconds / 1e9;
        const jsDate = new Date(unixTimestamp * 1000);

        const formattedDate = moment(jsDate).format("DD/MM/YYYY HH:mm");
        return formattedDate;
    };
    const onPurchaseSuccess = (order) => {
        let payload = {
            amount: order?.purchase_units[0]?.amount,
            payment_id: order.id,
            athlete_id: buyMomentoObj?.athlete_id,
            fan_id: uid,
            downloads: 0,
            isPayout: false,
            isRefunded: false,
            momentoId: buyMomentoObj?.id,
            type: "normal",
            via: "paypal",
        };
        dispatch(
            buyMomento(payload, () => {
                setBuyMomentoIndex(-1);
                setBuyMomentoObj("");
                toast.success("Memento Purchased");
                setAcceptedRules(false);
            })
        );
    };

    const loadMore = () => {
        setLoader((prev) => ({
            ...prev,
            loadMore: true,
        }));
        dispatch(
            getAllMomentos(
                {
                    athleteFirstName: "",
                    momentoID: "",
                    athleteID: "",
                },
                lastFanGalleryDocument,
                () => {
                    setLoader((prev) => ({
                        ...prev,
                        loadMore: false,
                    }));
                }
            )
        );
    };
    const applyFilter = () => {
        setLoader((prev) => ({
            ...prev,
            applyFilter: true,
        }));
        dispatch(
            getAllMomentos(
                {
                    athleteFirstName: searchByFirstName,
                    momentoID: searchByMementoID,
                    athleteID: searchByID,
                },
                "",
                () => {
                    setLoader((prev) => ({
                        ...prev,
                        applyFilter: false,
                    }));
                }
            )
        );
    };
    const clearFilter = () => {
        setLoader((prev) => ({
            ...prev,
            clearFilter: true,
        }));
        setSearchByFirstName("");
        setSearchByMementoID("");
        setSearchByID("");
        dispatch(
            getAllMomentos(
                { athleteFirstName: "", momentoID: "", athleteID: "" },
                "",
                () => {
                    setLoader((prev) => ({
                        ...prev,
                        clearFilter: false,
                    }));
                }
            )
        );
    };

    return (
        <Container fluid>
            <Row className="justify-content-center mx-4 py-3">
                <h3>Memento Gallery</h3>
            </Row>

            {fanLoading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <>
                    <Row className="justify-content-center justify-content-lg-between mx-5 py-3">
                        <Col lg={3} sm={10} className="mb-3 mb-lg-0">
                            <Input
                                placeholder="Search By Athlete Name"
                                value={searchByFirstName}
                                onChange={(e) =>
                                    setSearchByFirstName(e.target.value)
                                }
                            />
                        </Col>
                        {/* <Col lg={3} sm={10} className="mb-3 mb-lg-0">
                            <Input
                                placeholder="Search By Athlete Last Name"
                                value={searchByLastName}
                                onChange={(e) =>
                                    setSearchByLastName(e.target.value)
                                }
                            />
                        </Col> */}
                        <Col lg={3} sm={10} className="mb-3 mb-lg-0">
                            <Input
                                placeholder="Search By Memento ID"
                                value={searchByMementoID}
                                onChange={(e) =>
                                    setSearchByMementoID(e.target.value)
                                }
                            />
                        </Col>
                        <Col lg={3} sm={10}>
                            <Input
                                placeholder="Search By Athlete ID"
                                value={searchByID}
                                onChange={(e) => setSearchByID(e.target.value)}
                            />
                        </Col>
                        <Col lg={3} sm={10} className="mt-3 mt-lg-0">
                            <Button
                                color="primary"
                                disabled={loader.applyFilter}
                                onClick={applyFilter}
                            >
                                {loader.applyFilter ? (
                                    <Spinner size="sm" />
                                ) : (
                                    "Apply"
                                )}
                            </Button>
                            <Button
                                className="mx-2"
                                color="danger"
                                disabled={loader.clearFilter}
                                onClick={clearFilter}
                            >
                                {loader.clearFilter ? (
                                    <Spinner size="sm" />
                                ) : (
                                    "Clear"
                                )}
                            </Button>
                        </Col>
                    </Row>
                    <Container>
                        {momentosGallery?.map((item, index) => {
                            return (
                                <>
                                    <Card
                                        className={`mb-5  p-4 create_momento-card ${
                                            index == 0 ? "mt-5" : ""
                                        }`}
                                        key={item.id}
                                    >
                                        <Row className="d-flex justify-content-center">
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Memento Title</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.momentoTitle}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>
                                                        Memento Description
                                                    </Label>
                                                    <p>
                                                        <strong>
                                                            {
                                                                item?.momentoDescription
                                                            }
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Athlete</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.athleteName}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>Created</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.createdAt &&
                                                                formatDate(
                                                                    item?.createdAt
                                                                )}
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Memento ID</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.momentoID}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>Athlete ID</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.athleteID}
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                        {allowDetailsIndex == index && (
                                            <Container className="d-flex flex-column momento__media">
                                                <Row className="p-3 flex-nowrap">
                                                    <Col className="col-1 d-flex flex-column justify-content-around pt-5 mr-1 pl-0 momento__media-qrCode_col">
                                                        {item.qrCodes?.map(
                                                            (qrCode, qrIdx) => {
                                                                if (
                                                                    qrIdx ==
                                                                        0 ||
                                                                    qrIdx == 1
                                                                ) {
                                                                    return (
                                                                        <>
                                                                            {qrCode !==
                                                                            "" ? (
                                                                                <div className="position-relative">
                                                                                    <img
                                                                                        src={
                                                                                            qrCode instanceof
                                                                                            File
                                                                                                ? URL.createObjectURL(
                                                                                                      qrCode
                                                                                                  )
                                                                                                : qrCode
                                                                                        }
                                                                                        className="w-100 create_momento-QR_img"
                                                                                        alt={`QR Code ${qrIdx}`}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </Col>

                                                    {item?.momento?.map(
                                                        (momentoItem) => {
                                                            return (
                                                                <Col className="p-2 momento__media-card">
                                                                    <Card className="w-100 p-3 create_momento-card d-flex flex-column justify-content-start align-items-center">
                                                                        <p className="mt-3 text-capitalize">
                                                                            <strong>
                                                                                {
                                                                                    momentoItem.title
                                                                                }
                                                                            </strong>
                                                                        </p>
                                                                        <p className="mt-3 text-capitalize">
                                                                            {
                                                                                momentoItem.subTitle
                                                                            }
                                                                        </p>

                                                                        <div className="create_momento__media-div">
                                                                            {momentoItem?.media ? (
                                                                                <img
                                                                                    src={
                                                                                        momentoItem.media
                                                                                    }
                                                                                    alt="img"
                                                                                    className="w-100 create_momento__media-div_img"
                                                                                />
                                                                            ) : (
                                                                                <>
                                                                                    No
                                                                                    Media
                                                                                    Attached
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </Card>
                                                                </Col>
                                                            );
                                                        }
                                                    )}
                                                    <Col className="col-1 d-flex flex-column-reverse justify-content-around pt-5 mr-1 pr-0 momento__media-qrCode_col">
                                                        {item.qrCodes?.map(
                                                            (qrCode, qrIdx) => {
                                                                if (
                                                                    qrIdx ===
                                                                        item
                                                                            .qrCodes
                                                                            .length -
                                                                            2 ||
                                                                    qrIdx ===
                                                                        item
                                                                            .qrCodes
                                                                            .length -
                                                                            1
                                                                ) {
                                                                    return (
                                                                        <>
                                                                            {qrCode !==
                                                                            "" ? (
                                                                                <div className="position-relative">
                                                                                    <img
                                                                                        src={
                                                                                            qrCode instanceof
                                                                                            File
                                                                                                ? URL.createObjectURL(
                                                                                                      qrCode
                                                                                                  )
                                                                                                : qrCode
                                                                                        }
                                                                                        className="w-100 create_momento-QR_img"
                                                                                        alt={`QR Code ${qrIdx}`}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row className="d-flex justify-content-between align-items-center mx-0 px-0 my-3 flex-nowrap">
                                                    {item.qrCodes?.map(
                                                        (qrCode, qrIdx) => {
                                                            if (
                                                                qrIdx >= 2 &&
                                                                qrIdx <
                                                                    item.qrCodes
                                                                        .length -
                                                                        2
                                                            ) {
                                                                return (
                                                                    <div className="momento__media-qrCode_row">
                                                                        {qrCode !==
                                                                        "" ? (
                                                                            <div className="position-relative">
                                                                                <img
                                                                                    src={
                                                                                        qrCode instanceof
                                                                                        File
                                                                                            ? URL.createObjectURL(
                                                                                                  qrCode
                                                                                              )
                                                                                            : qrCode
                                                                                    }
                                                                                    className="w-100 create_momento-QR_img"
                                                                                    alt={`QR Code ${qrIdx}`}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </Row>
                                            </Container>
                                        )}

                                        <Row className="pr-4 my-3 justify-content-center justify-content-md-end">
                                            <Button
                                                size="sm"
                                                color="primary"
                                                onClick={() => {
                                                    if (
                                                        allowDetailsIndex ==
                                                        index
                                                    ) {
                                                        setAllowDetailsIndex(
                                                            -1
                                                        );
                                                    } else {
                                                        setAllowDetailsIndex(
                                                            index
                                                        );
                                                    }
                                                }}
                                            >
                                                {allowDetailsIndex == index
                                                    ? "Hide Details"
                                                    : "View Details"}
                                            </Button>

                                            <Button
                                                size="sm"
                                                color="primary"
                                                className="mx-3"
                                                onClick={() => {
                                                    let onError = () => {
                                                        toast.error(
                                                            "You Already Bought this Memento"
                                                        );
                                                    };
                                                    let onSuccess = () => {
                                                        setBuyerModal(true);
                                                        setBuyMomentoIndex(
                                                            index
                                                        );
                                                        setBuyMomentoObj(item);
                                                    };
                                                    dispatch(
                                                        checkBoughtMomentos(
                                                            uid,
                                                            item?.id,
                                                            onSuccess,
                                                            onError
                                                        )
                                                    );
                                                }}
                                            >
                                                Buy Memento
                                            </Button>
                                        </Row>
                                        {buyMomentoIndex == index &&
                                            !buyerModal && (
                                                <Row className="justify-content-center">
                                                    <Col className="col-2">
                                                        <Paypal
                                                            amount={
                                                                Number(
                                                                    buyMomentoObj?.momentoAmount
                                                                ) + 0.5 || 20.5
                                                            }
                                                            onPurchaseSuccess={
                                                                onPurchaseSuccess
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                    </Card>
                                </>
                            );
                        })}
                        <div className="mt-2 mb-4 text-center">
                            {fanGallery.length > 9 && (
                                <Button
                                    color="primary"
                                    size="sm"
                                    className="mr-3"
                                    disabled={
                                        loader.loadMore || !hasMoreFanGallery
                                    }
                                    onClick={loadMore}
                                >
                                    {loader.loadMore ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        "Load More"
                                    )}
                                </Button>
                            )}
                        </div>
                    </Container>
                </>
            )}
            <Modal
                isOpen={buyerModal}
                toggle={() => {
                    setBuyMomentoObj("");
                    setBuyMomentoIndex(-1);
                    setBuyerModal(false);
                }}
            >
                <ModalHeader
                    toggle={() => {
                        setBuyMomentoObj("");
                        setBuyMomentoIndex(-1);
                        setBuyerModal(false);
                    }}
                >
                    Rules For Buyers
                </ModalHeader>
                <ModalBody>
                    <ol className="notice__list" type="A">
                        <li>
                            I understand that all buyers must be 18 years or
                            older.
                        </li>
                        <li>
                            I understand that, while the content of photos in
                            the mementos for sale here may be visible pre-sale
                            to buyers, the full contents of videos, etc. linked
                            to memento QR codes may not be visible pre-sale. I
                            understand that FHP does not guarantee such content
                            to be to buyer taste or wholesome or
                            non-objectionable.
                        </li>
                        <li>
                            I understand my purchase of a memento is
                            non-refundable.
                        </li>
                        <li>
                            I agree to promptly report objectional mementos to
                            FHP Admin.
                        </li>
                        <li>
                            I agree not to make copies for purpose of supplying
                            to other users.
                        </li>
                    </ol>
                    <FormGroup check inline>
                        <Label check className="ml-4 mr-2">
                            Click to signify agreement:
                        </Label>
                        <Input
                            className="mb-0"
                            type="checkbox"
                            checked={acceptedRules}
                            onClick={() => setAcceptedRules(!acceptedRules)}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="sm"
                        color="danger"
                        onClick={() => {
                            setBuyMomentoObj("");
                            setBuyMomentoIndex(-1);
                            setBuyerModal(false);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        disabled={!acceptedRules}
                        onClick={() => setBuyerModal(false)}
                    >
                        OK
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default Gallery;
